export const LOGIN_ERROR_HEADER = `Oops! That didn't work.`
export const LOGIN_INVALID_EMAIL = 'Please enter a valid Email Address.'
export const LOGIN_AUCTIONCOM_EMAIL = 'Please use auction.okta.com to sign in.'
export const LOGIN_INCORRECT_CREDS =
  'Your username and/or password are incorrect.'
